import React, { useState } from "react";
import { Play, ChevronRight } from "lucide-react";
import SwissFlag from "./SwissFlag";
import { HERO, IMAGES } from "../mock";
import {
  Dialog,
  DialogContent,
} from "./ui/dialog";

function getYouTubeId(url) {
  const m = url.match(/(?:v=|\.be\/)([\w-]+)/);
  return m ? m[1] : "";
}

export default function Hero() {
  const [openVideo, setOpenVideo] = useState(false);
  const ytId = getYouTubeId(HERO.videoUrl);

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="hero"
      style={{ backgroundImage: `url(${IMAGES.heroBg})` }}
    >
      <div className="container mx-auto px-4 max-w-[1200px] w-full text-center">
        <div className="flex justify-center mb-6">
          <span className="swiss-badge">
            <SwissFlag /> Made in Switzerland · SaaS Software
          </span>
        </div>

        <h1 className="mx-auto max-w-[900px]">
          <span className="accent">{HERO.brand}</span>
          <br />
          {HERO.title}
        </h1>

        <p>{HERO.subtitle}</p>

        <div className="flex items-center justify-center gap-4 flex-wrap mb-16">
          <button className="btn-theme" onClick={() => scrollTo("#contact")}>
            {HERO.cta} <ChevronRight size={18} />
          </button>
          <button className="btn-outline-light" onClick={() => scrollTo("#features")}>
            Mehr erfahren
          </button>
        </div>

        {/* Dashboard mockup */}
        <div className="max-w-[880px] mx-auto" style={{ animation: "floaty 6s ease-in-out infinite" }}>
          <div className="hero-thumb">
            <img src={IMAGES.dashboard} alt="InteliSoft Dashboard" />
            <button
              className="play-btn"
              onClick={() => setOpenVideo(true)}
              aria-label="Video abspielen"
            >
              <Play size={26} fill="currentColor" />
            </button>
          </div>
        </div>
      </div>

      <Dialog open={openVideo} onOpenChange={setOpenVideo}>
        <DialogContent className="max-w-3xl p-0 overflow-hidden border-0 bg-black">
          <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
            {openVideo && (
              <iframe
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube.com/embed/${ytId}?autoplay=1`}
                title="InteliSoft Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
}
